import * as actionCreator from "@utils/actionCreator.js";
import * as effect from "./externalServices.effect.js";
import { notify } from "@app/notification/notification.action.js";
import { tr } from "@utils/translation.js";

const SLICE = "externalServices";


export const CAMPAIGN_IS_LOADING_EXTERNAL_SERVICES = `${SLICE}/IS_LOADING_EXTERNAL_SERVICES`;
export const CAMPAIGN_SET_ALL_EXTERNAL_SERVICES = `${SLICE}/SET_ALL_EXTERNAL_SERVICES`;
export const fetchExternalServices = (campno) => async (dispatch) => {
  
  dispatch(actionCreator.createAction(CAMPAIGN_IS_LOADING_EXTERNAL_SERVICES));
  
  const response = await effect.fetchExternalServices(campno);
  if (response.error) {
    dispatch(actionCreator.createAction(CAMPAIGN_SET_ALL_EXTERNAL_SERVICES, []));
    return;
  }
  dispatch(actionCreator.createAction(CAMPAIGN_SET_ALL_EXTERNAL_SERVICES, response));
};

export const addExternalService = (externalServices, callback = () => { }) => async (dispatch) => {

  const response = await effect.addExternalService(externalServices);
  if (response.error) {
    dispatch(notify(tr("dbConnectFailure"), "error"));
    return;
  }
  callback();
  dispatch(notify(tr("externalServicesAdded"), "success"));
  dispatch(fetchExternalServices(externalServices.campno))
}

export const CAMPAIGN_SET_REMOVING_EXTERNAL_SERVICES = `${SLICE}/SET_REMOVING_EXTERNAL_SERVICES`;
export const CAMPAIGN_EXTERNAL_SERVICES_REMOVED = `${SLICE}/EXTERNAL_SERVICES_REMOVED`;
export const removeExternalService = (campno, entno, callback = () => { }) => async (dispatch) => {

  dispatch(actionCreator.createAction(CAMPAIGN_SET_REMOVING_EXTERNAL_SERVICES, true));

  const response = await effect.removeExternalService(campno, entno);
  if (response.error) {
    dispatch(notify(tr("dbConnectFailure"), "error"));
    dispatch(actionCreator.createAction(CAMPAIGN_SET_REMOVING_EXTERNAL_SERVICES, false));
    return;
  }

  callback();
  dispatch(notify(tr("externalServicesRemoved"), "warning"));
  dispatch(actionCreator.createAction(CAMPAIGN_SET_REMOVING_EXTERNAL_SERVICES, false));
  dispatch(actionCreator.createAction(CAMPAIGN_EXTERNAL_SERVICES_REMOVED, true));
  dispatch(fetchExternalServices(campno))
};

export const CAMPAIGN_EXTERNAL_SERVICES_EDITED = `${SLICE}/CAMPAIGN__EXTERNAL_SERVICES_EDITED`;
export const updateExternalService = (externalServices, callback = () => { }) => async (dispatch) => {
  const response = await effect.updateExternalServices(externalServices, externalServices.campno);
  if (response.error) {
    dispatch(notify(tr("dbConnectFailure"), "error"));
    return;
  }
  callback();
  dispatch(notify(tr("externalServicesEdited"), "success"));
  dispatch(fetchExternalServices(externalServices.campno))

};

// subs external services

export const EXTERNAL_SERVICES_IS_LOADING_SUBS_EXTERNAL_SERVICES = `${SLICE}/IS_LOADING_SUBS_EXTERNAL_SERVICES`;
export const EXTERNAL_SERVICES_SET_ALL_SUBS_EXTERNAL_SERVICES = `${SLICE}/SET_ALL_SUBS_EXTERNAL_SERVICES`;
export const fetchSubsExternalServices = (subsNo, extNo, entitlementNo) => async (dispatch) => {
  
  dispatch(actionCreator.createAction(EXTERNAL_SERVICES_IS_LOADING_SUBS_EXTERNAL_SERVICES));
  const response = await effect.fetchSubsExternalServices(subsNo, extNo, entitlementNo);
  if (response.error) {
    dispatch(actionCreator.createAction(EXTERNAL_SERVICES_SET_ALL_SUBS_EXTERNAL_SERVICES, []));
    return;
  }
  dispatch(actionCreator.createAction(EXTERNAL_SERVICES_SET_ALL_SUBS_EXTERNAL_SERVICES, response));
};

export const EXTERNAL_SERVICES_SET_REMOVING_EXTERNAL_SERVICES = `${SLICE}/SET_REMOVING_EXTERNAL_SERVICES`;
export const EXTERNAL_SERVICES_EXTERNAL_SERVICES_REMOVED = `${SLICE}/EXTERNAL_SERVICES_REMOVED`;
export const removeSubsExternalService = (subsNo, extNo, entitlementNo, callback = () => { }) => async (dispatch) => {
  dispatch(actionCreator.createAction(EXTERNAL_SERVICES_SET_REMOVING_EXTERNAL_SERVICES, true));

  const response = await effect.removeSubsExternalService(subsNo, extNo, entitlementNo);
  if (response.error) {
    dispatch(notify(tr("dbConnectFailure"), "error"));
    dispatch(actionCreator.createAction(EXTERNAL_SERVICES_SET_REMOVING_EXTERNAL_SERVICES, false));
    return;
  }

  callback();
  dispatch(notify(tr("externalServicesRemoved"), "warning"));
  dispatch(actionCreator.createAction(EXTERNAL_SERVICES_SET_REMOVING_EXTERNAL_SERVICES, false));
  dispatch(actionCreator.createAction(EXTERNAL_SERVICES_EXTERNAL_SERVICES_REMOVED, true));
  dispatch(fetchSubsExternalServices(subsNo, extNo))
};

export const addSubsExternalService = (externalService, callback = () => { }) => async (dispatch) => {

  const response = await effect.addSubsExternalService(externalService);
  if (response.error) {
    dispatch(notify(tr("dbConnectFailure"), "error"));
    return;
  }
  callback();
  dispatch(notify(tr("externalServicesAdded"), "success"));
  dispatch(fetchSubsExternalServices(externalService.subsno, externalService.extno))
}

export const EXTERNAL_SERVICES_EXTERNAL_SERVICE_EDITED = `${SLICE}/EXTERNAL_SERVICES_EXTERNAL_SERVICE_EDITED`;
export const updateSubsExternalService = (externalService, callback = () => { }) => async (dispatch) => {
  const response = await effect.updateSubsExternalServices(externalService);
  if (response.error) {
    dispatch(notify(tr("dbConnectFailure"), "error"));
    return;
  }
  callback();
  dispatch(notify(tr("externalServicesEdited"), "success"));
  dispatch(fetchSubsExternalServices(externalService.subsno, externalService.extno))
};


